import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptStorno: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReceiptStorno"><Path d="M8.5 14.5H15.5M14 7.25L12 9.25M12 9.25L10 11.25M12 9.25L10 7.25M12 9.25L14 11.25M4.5 2.5H19.5V21.5L17 19L14.5 21.5L12 19L9.5 21.5L7 19L4.5 21.5V2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconReceiptStorno;
